import { useTheme } from '@mui/material'

// const useStyles = makeStyles({ name: 'pdf-highlight' })((theme) => ({
//   active: {
//     animation:
//       'vibrate-3-normal 1s cubic-bezier(0.445, 0.050, 0.550, 0.950) 0.5s 1 normal none',
//   },
// }))
export const useHighlightColor = ({
  isActiveCheckListFeature,
  isDoneCheckListFeature,
  isCheckListFeature,
}: {
  isActiveCheckListFeature: boolean
  isDoneCheckListFeature: boolean
  isCheckListFeature: boolean
}) => {
  const theme = useTheme()
  // const { classes } = useStyles()
  let fillColor = {
    main: theme.palette.info.light,
    dark: theme.palette.warning.dark,
  }

  let opacity = 0.5

  if (isCheckListFeature) {
    fillColor = theme.palette.warning
    opacity = 0.5
  }

  if (isDoneCheckListFeature) {
    fillColor = theme.palette.success
    opacity = 0.8
  }

  let classNames = ''
  // if (isActiveCheckListFeature) {
  //   classNames = `${classes.active}`
  // }
  const activeStrokeColor = theme.palette.primary.dark

  return { fillColor, opacity, classNames, activeStrokeColor }
}
